module.exports = __webpack_public_path__ + "img/1.e4c77d4d.jpg";